import { RecommendPanel } from '@doda/common/src/interfaces/api/recommendPanel';
import { useEffect, useState } from 'react';
import { useAppSelector } from 'redux/hooks';
import { jobListSelector } from 'redux/features/jobList';
import { JobSearchResultResponse } from '@doda/api-client/aspida/@types';
import {
  getDefaultRecommendPanel,
  getRecommendPanel,
} from 'pages/DodaFront/View/JobSearchList/logics/getRecommendPanel';
import { B4rTsuukaAbTestPattern } from 'pages/DodaFront/View/JobSearchList/types/analytics';

const getJobListTop5Item = (jobListRes: JobSearchResultResponse[]) => {
  const jobListTop5Item: string[] = [];

  if (jobListRes.length >= 5) {
    for (let i = 0; i < 5; i += 1) {
      const { jid } = jobListRes[i];
      if (jid) {
        jobListTop5Item.push(jid);
      }
    }
  } else {
    for (let i = 0; i < jobListRes.length; i += 1) {
      const { jid } = jobListRes[i];
      if (jid) {
        jobListTop5Item.push(jid);
      }
    }
  }

  return jobListTop5Item;
};

interface RecommendResult {
  recommendForSlider: RecommendPanel | null;
  recommendForList: RecommendPanel | null;
}

const initialState: RecommendResult = {
  recommendForSlider: null,
  recommendForList: null,
};

/**
 * レコメンドデータを取得
 * @param b4rTsuukaABTestPattern AB test type for B4R recommend
 * @returns レコメンドデータ
 */
export const useRecommend = (
  b4rTsuukaABTestPattern: B4rTsuukaAbTestPattern
) => {
  const jobListRes = useAppSelector(jobListSelector);
  const [recommend, setRecommend] = useState<RecommendResult>(initialState);

  useEffect(() => {
    const jobListTop5Item = getJobListTop5Item(jobListRes);
    (async () => {
      try {
        const res = await getRecommendPanel(
          jobListTop5Item,
          b4rTsuukaABTestPattern
        );
        if (!res) throw new Error('No Response');
        setRecommend((pre) => ({ ...pre, recommendForList: res }));
      } catch {
        try {
          const res = await getDefaultRecommendPanel(b4rTsuukaABTestPattern);
          if (res) setRecommend((pre) => ({ ...pre, recommendForSlider: res }));
        } catch {
          // 両方のリクエストデータが取得できなかった場合は非表示
        }
      }
    })();
  }, [jobListRes, b4rTsuukaABTestPattern]);

  return recommend;
};
